import React from 'react';
import styled from 'styled-components';
import Button from 'components/buttons/simple';
import { EUpdateModalTitle } from 'lib/storage';
import { CloseIcon, ButtonContainer, CancelButton } from 'components/formula-entry/modals/_common';
import colors from 'theme/colors';
import { ModalContainerDark, PostNewUpdateModal } from 'components/modal-provider/modal';
import '../styles.scss';
import { TPostUpdateModalProps } from '.';

const { darkBorder, yellow } = colors;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: ${colors.platinum};
  margin-bottom: 24px;
`;

export const SaveButton = styled(Button)`
  background-color: ${yellow};
  color: ${darkBorder};
  margin-left: 8px;
`;

const HeaderContainer = styled.div`
  text-align: left;
  position: relative;
`;

export const Header = styled.div`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 24px;
  line-height: 25px;
`;

export const SubHeader = styled.div`
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 24px;
  line-height: 19px;
`;

export default ({
  setPostUpdateModalIsOpen,
  isPostUpdateModalOpen,
  setAddNewUpdateModalIsOpen,
  setPostUpdateConfirmButtonPressed,
  postNewUpdate,
}: TPostUpdateModalProps) => {
  if (!isPostUpdateModalOpen) {
    return null;
  }

  return (
    <ModalContainerDark data-testid="post-update-modal">
      <PostNewUpdateModal>
        <Container>
          <HeaderContainer>
            <Header>Post Update?</Header>
            <CloseIcon
              onClick={() => {
                setAddNewUpdateModalIsOpen(false, EUpdateModalTitle.NEW_UPDATE);
                setPostUpdateModalIsOpen(false);
                setPostUpdateConfirmButtonPressed(false);
              }}
            />
          </HeaderContainer>
          <SubHeader>
            Once posted, update will be displayed on the what’s new page and on the dashboard screen.
            <br />
            <br />
            Do you want to continue?
          </SubHeader>
          <ButtonContainer>
            <CancelButton
              onClick={() => {
                setAddNewUpdateModalIsOpen(false, EUpdateModalTitle.NEW_UPDATE);
                setPostUpdateModalIsOpen(false);
                setPostUpdateConfirmButtonPressed(false);
              }}
            >
              Cancel
            </CancelButton>
            <SaveButton
              onClick={() => {
                setAddNewUpdateModalIsOpen(false, EUpdateModalTitle.NEW_UPDATE);
                setPostUpdateModalIsOpen(false);
                setPostUpdateConfirmButtonPressed(true);
                postNewUpdate();
              }}
            >
              Yes, Post Update
            </SaveButton>
          </ButtonContainer>
        </Container>
      </PostNewUpdateModal>
    </ModalContainerDark>
  );
};
